<template>
  <div>
    <ButtonDelete
      aria-label="Open Deletion Modal"
      @click="handleOpenDeleteModal"
    />
    <DeleteKeyModal
      :bodyTextEmphasized="bodyTextEmphasized"
      :headerText="headerText"
      :isOpen="isModalOpen"
      @cancel="handleCloseDeleteModal"
      @confirm="handleDelete"
    />
  </div>
</template>

<script>
import { ButtonDelete } from '@jumpcloud/ui-components';
import { getDeleteBodyTextDeviceType, getDeleteModalHeader } from 'client/systemusers/UserDetails/WebAuthnKeys/webAuthnHelpers';
import { mapActions } from 'vuex';
import DeleteKeyModal from 'client/systemusers/UserDetails/WebAuthnKeys/DeleteKeyModal.vue';

export default {
  name: 'DeleteKey',

  components: {
    ButtonDelete,
    DeleteKeyModal,
  },

  props: {
    webAuthnKey: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isModalOpen: false,
    };
  },

  computed: {
    bodyTextEmphasized() {
      return `Are you sure you want to delete this ${getDeleteBodyTextDeviceType(this.webAuthnKey)}?`;
    },

    headerText() {
      return getDeleteModalHeader(this.webAuthnKey);
    },
  },

  methods: {
    ...mapActions('SystemUserWebAuthnKeysModel', [
      'deleteWebAuthnKey',
    ]),

    handleCloseDeleteModal() {
      this.isModalOpen = false;
    },

    handleDelete() {
      this.deleteWebAuthnKey(this.webAuthnKey);
      this.handleCloseDeleteModal();
    },

    handleOpenDeleteModal() {
      this.isModalOpen = true;
    },
  },
};
</script>
